import {Coordinate} from "ol/coordinate"
import {WKT} from "ol/format"
import {merge} from "lodash-es"
import {apiCall} from "@ui/api/common"
import {TPoiCategory} from "@ui/stores/service/poi"

export type TPointProps = {
  color: number
  title: string
  more: string | null
}
export type TPoint = {
  id: number
  props: TPointProps
  point: Coordinate
}
export type TShortPoint = {
  id: number
  color: number
  title: string
  type: TPoiCategory
  favorite: boolean
}
export type TFullPoint = {
  geometry: WKT
  props: {
    id: number
    color: number
    type: TPoiCategory
    favorite: boolean
    values: {code: string, value: string, format?: string}[]
  }
}

export type TCategory = {
  code: TPoiCategory
  category: string
}

export type TFilter = {
	name?: string
	favorite?: true
  spot_type?: TPoiCategory
  within?: [number, number, number]
}
type TSearchPointProps = {
	page?: number
	size?: number
  filter: TFilter
}

export const getCategories = () => apiCall().get<TCategory[]>("/poi2/categories")

export const save = (point: Omit<TPoint, "id">) => apiCall()
	.post<{id: number}>("/poi2/save", point)

export const update = (id: number, props: TPointProps) => apiCall()
	.post<{id: number}>(`/poi2/update/${id}`, props)

export const purge = (id: number) => apiCall().delete<void>(`/poi2/delete/${id}`)

export const pageSize = 10
export const search = ({
  page = 0,
  size = pageSize,
  filter = {}
}: TSearchPointProps) =>
  apiCall().post<TShortPoint[]>(
    "/poi2/search",
    {page, size, filter: merge({name: null, favorite: null, spot_type: null, within: null}, filter)}
  )

export const load = (id: number) => apiCall().get<TFullPoint>(`poi2/load/${id}`)

export const mark = (id: number) => apiCall().patch<{favorite: boolean}>(`/poi2/mark/${id}`)

export const correct = (id: number, info: string) => apiCall().post(
  `feedback/spot/correction/${id}`,  {info}
)

export const publish = (id: number, info: string) => apiCall().post(
  `feedback/spot/publish/${id}`,  {info}
)
